module.exports = __webpack_public_path__ + "static/media/user.79c95c64.jpg";